import React, { Fragment, useContext, useEffect, useState, memo } from "react";
import { Link } from "react-router-dom";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";
import cx from "classnames";

// Provider
import { Container, DateTimeLayer, pickerStartFn } from "../../Layout";

import _NoImage from "../../../resources/images/icon/icon_noodle_gray.png";
import { SubMenu, SUBS } from "./SubMenu";

export default () => {
    const sub = SUBS[0];
    const [ tapType, setTapType ] = useState(0);

    useEffect(() => {
        //섭취한 음식 체크
        $(".search-result-list a.btn-circcheck").click(function(){
            $(this).parent("li").toggleClass("on");
        });
    }, []);

    return(
        <Fragment>
            <ScrollToTop />
            <Container Title={sub.label} bottom={null} goToUrl="/sm">
                <div className="contents sub">
                    <SubMenu code='rcnt' /> 
                    <div className="sub-contents">
                        <div className="sub-title">식단 입력</div>
                        <div className="meal-select-date npd">
                            <div className="select-input">
                                <div>
                                    <div className="select-custom-box">
                                        <a className="btn-select">아침</a>
                                        <ul>
                                            <li><a>아침</a></li>
                                            <li><a>점심</a></li>
                                            <li><a>저녁</a></li>
                                            <li><a>간식</a></li>
                                            <li><a>야식</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div>
                                    <input type="text" className="textbox datetime-picker-input pick-result" placeholder="날짜/시간을 선택해 주세요." onClick={()=>pickerStartFn()} readOnly />
                                </div>
                            </div>					
                        </div>

                        {/* <!-- 하단 이미지삽입시 he1  클래스 빼주세요. --> */}
                        <div className="empty-graybox he1">
                            <a className="">
                                <span></span>
                                <p>식단사진을 첨부해주세요.</p>
                            </a> 
                            {/* <div class="inimg">
                                <img src="images/user/user_meal_photo01.jpg" alt="" />
                            </div> */}
                        </div>

                        <div className="under-tab-area">
                            <a onClick={()=>setTapType(0)} className={tapType===0 ? "on" : ""}>최근 검색 음식</a>
                            <a onClick={()=>setTapType(1)} className={tapType===1 ? "on" : ""}>자주먹는 음식</a>
                        </div>

                        <div className="green-box-search">
                            <input type="text" className="textbox" placeholder="음식을 검색해주세요."  maxLength="30"/>
                            <a className="btn-gr-search"></a>
                        </div>
                        
                        <div className="search-keyword-box">
                            <div className="horizon-tabs-group">
                                <ul>
                                    <li><span className="first"><a><i></i>초기화</a></span></li>
                                    <li><span><a>고등어(1.0)</a><u>X</u></span></li>
                                    <li><span><a>견과류(1.0)</a><u>X</u></span></li>
                                    <li><span><a>현미밥(1.0)</a><u>X</u></span></li>
                                    <li><span><a>고등어(1.0)</a><u>X</u></span></li>
                                    <li><span><a>견과류(1.0)</a><u>X</u></span></li>
                                    <li><span><a>현미밥(1.0)</a><u>X</u></span></li>
                                </ul>
                            </div>
                        </div>
                        
                        {/* length로 구분하여 표시 or Nothing으로 표시 */}
                        {tapType === 0
                            ? <FoodList />
                            : <Nothing />
                        }
                        
                        <div className="section-box">
                            <div className="sub-title">메모</div>
                            <div>
                                <textarea className="textarea-box gray he1" placeholder="메모를 입력해주세요."></textarea>
                            </div>
                        </div>

                        <div className="section-box">
                            <div className="two-btns-area">
                                <a>취소</a>
                                <a className="">확인</a>
                            </div>
                        </div>
                    </div>

                </div>
            </Container>
            {/* setBpcDate={setBpcDate} setBpcTime={setBpcTime} */}
            <DateTimeLayer /> 
        </Fragment>
    )
}

const Nothing = () => {
    return(
        <div className="search-not-box">
            <img src={_NoImage} alt="" />
            <p>자주먹는 음식 정보가 없습니다.</p>
        </div>
    );
}

const FoodList = () => {
    // list 세팅
    return(
        <div className="search-result-list">
            <div className="toptt">
                <i>!</i> 섭취한 음식의 양을 설정 후 선택해주세요. 
            </div>
            <ul>
                <AddedList />
            </ul>
            <div className="bot-close">
                <a>검색결과 닫기<i></i></a>
            </div>
        </div>
    );
}

const AddedList = (props) => {
    const { data } = props; 
    return(
        <li className="on">
            현미밥
            <div className="count-updown">
                <a className="btn-mius"></a>
                <p>1.0</p>
                <a className="btn-plus"></a>
            </div>
            <a className="btn-circcheck"></a>
        </li>
    );
}